@if (isEmpty()) {
  <span>{{'---'}}</span>
} @else {
  <ng-container *ngComponentOutlet="renderer(); inputs: rendererInputs()" />
}
